import React from 'react';
import { Button } from 'chic-ui';
import { Row } from 'react-bootstrap';

const Disabled = () => {
  return (
    <>
      <h4 className="mt-5">Disabled Buttons</h4>
      <p>Using the <i>disabled </i> prop you can disable any type of button.</p>
      <div className="btn-group btns mt-3">
        <Button className="single-btn" disabled type='danger'>
          Disabled
        </Button>
        <Button className="single-btn" disabled type='success'>
          Disabled
        </Button>
      </div>
      <Row className="mt-3" fluid>
        <code>
          {'import { Button } from "chic-ui";'}
          <br />
          {'<Button type="danger" disabled>Disabled</Button>'}
          <br />
          {'<Button type="success" disabled>Disabled</Button>'}
        </code>
      </Row>
    </>
  );
};

export default Disabled;
